// @ts-nocheck
import { makeStyles } from '@material-ui/core';

const chipStyle = {
  fontSize: '12px',
  borderRadius: '4px',
  color: '#212529',
};

export const useHireTypeStyles = makeStyles(() => ({
  wetHire: {
    ...chipStyle,
    '& .MuiChip-label': {
      textOverflow: 'inherit',
    },
    background: '#F3F6FB',
  },
  dryHire: {
    ...chipStyle,
    '& .MuiChip-label': {
      textOverflow: 'inherit',
    },
    background: '#FFF4E3',
  },
  bothHire: {
    ...chipStyle,
    '& .MuiChip-label': {
      textOverflow: 'inherit',
    },
    background: '#DBEFDC',
  },
}));
